let defaultLibrary = 'echarts';
export function getDefaultLibrary() {
    return defaultLibrary;
}
export function setDefaultLibrary(library) {
    defaultLibrary = library;
}
export const chartConfig = {
    get defaultLibrary() {
        return defaultLibrary;
    },
};
